import { RotationsplanFeatureState } from '@/domain/mitarbeiter/features/rotationsplan/features/shared/store';
import { StoreContext } from '@/domain/mitarbeiter/pages/rotationsplan/PageWrapper';
import { ReactNode, createContext, useContext } from 'react';
import { useStore } from 'zustand';

type RotationsplanFeatureContext = {
  store: RotationsplanFeatureState;
};

const RotationsplanFeatureContext =
  createContext<RotationsplanFeatureContext>(null);

export function RotationsplanFeatureProvider({
  children,
}: {
  children: ReactNode;
}) {
  const storeContext = useContext(StoreContext);
  const store = useStore(storeContext, (s) => s);
  const value = { store };

  return (
    <RotationsplanFeatureContext.Provider value={value}>
      {children}
    </RotationsplanFeatureContext.Provider>
  );
}

// eslint-disable-next-line react-refresh/only-export-components
export function useRotationsplanFeatureContext() {
  const rotationsplanFeatureContext = useContext(RotationsplanFeatureContext);
  return rotationsplanFeatureContext;
}
